import css from 'styled-jsx/css';

const styles = css.global`#perguntas  .disclaimer {
  margin-top: 16px;
}

#perguntas .disclaimer-text {
  color:#999;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 200;
  line-height: 22px;
}

#perguntas .perguntas-contain {
  margin-top: 48px;
  margin-bottom: 48px;
}

#perguntas .img-perguntas {
  width: 100%;
  height: 240px;
  object-fit: cover;
  object-position: top;
  border-radius: 4px;
}

#perguntas .group-perguntas {
  margin-top: 24px;
}

#perguntas .group-perguntas .title-perguntas {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin-bottom: 24px;
}

#perguntas .custom-accordion .acc-header .acc-title {
  color: #444;
  font-size: 18px;
  padding-right: 15px;
  line-height: 28px;
}
#perguntas .custom-accordion .acc-header {
  padding: 0 0 16px;
}

#perguntas .custom-accordion.mb-space {
  margin-bottom: 40px;
}
#perguntas .custom-accordion.opened .acc-header {
  background-color: #ffffff;
}

#perguntas .custom-accordion .acc-body.default p {
  color: #444;
  font-size: 18px;
  line-height: 1.56;
}

#perguntas a.btn-outline-red {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: -16px;
  display: block;
}

#perguntas a.btn-outline-red:hover {
  transition: all 350ms linear;
  text-decoration: underline;
}

@media (min-width: 992px) {
  #perguntas .disclaimer {
    margin-top: 8px;
  }

  #perguntas .custom-accordion .acc-header .acc-title {
    font-size: 18px;
    line-height: 28px;
  }

  #perguntas .perguntas-contain {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 0;
    margin-bottom: 3px;
  }

  #perguntas .img-perguntas {
    height: 540px;
    width: 420px;
    margin-top: 16px;
  }

  #perguntas .group-perguntas {
    margin-top: 0;
    width: 751px;
    padding: 0px 16px 24px 16px;
  }

  #perguntas .group-perguntas .title-perguntas  {
    text-align: left;
    line-height: 36px;
    margin-bottom: 40px;
  }

  #perguntas a.btn-outline-red{
    margin: 0;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
 
  #perguntas .custom-accordion .acc-header {
    padding: 0 16px 16px 0;
    min-height: auto;
  }

  #perguntas .custom-accordion .acc-body.default p {
    max-width: 590px;
  }
}
`;

export default styles;